"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("../style/index"));

var _input = _interopRequireDefault(require("../views/input"));

var _createStyled = require("../../../utils/createStyled");

var _listOverlay = _interopRequireDefault(require("../../DropDown/views/listOverlay.c"));

function template() {
  var _this = this;

  var list = null;

  var _this$props = this.props,
      _this$props$className = _this$props.className,
      className = _this$props$className === void 0 ? '' : _this$props$className,
      children = _this$props.children,
      value = _this$props.value,
      rest = (0, _objectWithoutProperties2["default"])(_this$props, ["className", "children", "value"]),
      _this$state = this.state,
      focus = _this$state.focus,
      focusedElement = _this$state.focusedElement,
      styles = this.compileStyled(_index["default"]),
      collection = this._filter();

  if (collection.length && // only one match equal with value
  !(collection.length === 1 && collection[0].props.value && collection[0].props.value.toLowerCase() === (value && value.toLowerCase()))) {
    list = collection.map(function (child, i) {
      var value = child.props.value;
      return _react["default"].createElement(_createStyled.Styled.Button, {
        key: value,
        type: "button",
        styles: styles.item,
        className: focusedElement === i ? 'focused' : '',
        onClick: function onClick() {
          return _this.select(child);
        },
        title: value || ''
      }, child);
    });
    list = _react["default"].createElement(_createStyled.Styled.Div, {
      styles: styles.list
    }, list);
  }

  this._currentFilteredList = collection;
  return _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.root,
    className: className
  }, _react["default"].createElement(_input["default"], (0, _extends2["default"])({}, rest, {
    elementRef: this._inputRef,
    onKeyDown: this._handleKeyDown,
    onFocus: this._handleFocus,
    onBlur: this._handleBlur,
    value: value
  })), _react["default"].createElement(_listOverlay["default"], {
    active: focus,
    zIndex: styles.list.zIndex
  }, list));
}